import api from '@/api';
import {
  FinancialCashFlowRequest,
  FinancialTrialBalance,
} from './Financial.types';
import { API_BASE_URL } from '..';

const baseUrl = API_BASE_URL;

export async function generateFinancialTrialBalance(
  params?: FinancialTrialBalance,
) {
  const result = (await api.getReport(
    `${baseUrl}/Financial/TrialBalance`,
    params,
  )) as unknown;

  return result as BlobPart;
}

export async function generateFinancialCashFlow(
  params?: FinancialCashFlowRequest,
) {
  const result = (await api.getReport(
    `${baseUrl}/Financial/CashFlow`,
    params,
  )) as unknown;

  return result as BlobPart;
}
